import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { ICheckServiceRequest } from '../../../../repositories/billing-tariffs/v3/check-service';
import { ICheckoutInfoState } from '../../../../types/reducers/checkoutInfo';
import { IOfferState, ICoordinates } from '../../../../types/reducers/offer';
import { getIsCommercial } from '../../../../utils/category/getIsCommercial';
import {
  checkJKCategory,
  checkBusinessCenterCategory,
  getJKId,
  getBusinessCenterId,
  isObjectSplits,
} from '../../../../utils/offer';
import { getIsCalltrackingPhoneChanged } from './getIsCalltrackingPhoneChanged';
import { EMoneySource } from '../../../../types/reducers/user';
import { getMultiListingSlotsCount } from '../../../../utils/commercialMultiAds/getMultiListingSlotsCount';
import { IPublicationTokens } from '../../../../types/reducers/publishTerms';

interface IGetCheckServiceParams {
  offer: IOfferState;
  locationPath: Array<number>;
  checkoutInfo: ICheckoutInfoState;
  terms: Array<ICheckPublishTermSchema>;
  isServiceChanged: boolean;
  photosCount: number;
  coordinates: ICoordinates;
  moneySource: EMoneySource | null;
  extraData: object;
  publicationTokens: IPublicationTokens;
}

export function getCheckServiceParams(params: IGetCheckServiceParams): ICheckServiceRequest {
  const {
    offer,
    locationPath,
    checkoutInfo,
    terms,
    isServiceChanged,
    photosCount,
    coordinates,
    moneySource,
    extraData,
    publicationTokens,
  } = params;

  const { id: objectId, category, bargainTerms, totalArea, areaParts } = offer;

  const {
    autoProlongInfo: { isChecked: autoProlong },
  } = checkoutInfo;

  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isMultiListing = isObjectSplits(offer);
  const userHasChangedCalltrackingPhone = getIsCalltrackingPhoneChanged(offer);

  const parameters: ICheckServiceRequest = {
    ...(isJKCategory && { newObjectId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(objectId && { objectId }),
    ...(category && { category }),
    locationPath: [...locationPath].reverse().join(','),
    autoProlong,
    terms,
    latitude: coordinates.lat,
    longitude: coordinates.lng,
    isMultiListing,
    userHasChangedServices: isServiceChanged,
    userHasChangedCalltrackingPhone,
    photosCount,
    sourceType: 'website',
    moneySource,
    extraData,
    uiType: 'webview',
    publication: publicationTokens,
  };

  const isCommercial = getIsCommercial(category);

  if (isCommercial) {
    Object.assign(parameters, {
      price: bargainTerms.price,
      currency: bargainTerms.currency,
      priceType: bargainTerms.priceType,
      paymentPeriod: bargainTerms.paymentPeriod,
      totalArea,
      multiListingSlotsCount: getMultiListingSlotsCount(areaParts),
    });
  }

  return parameters;
}
